import {
  booleanAttribute,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'glxy-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StickyFooterComponent {
  @HostBinding('class') class = 'glxy-sticky-footer';

  @HostBinding('class.right-aligned')
  @Input({ transform: booleanAttribute })
  rightAligned = false;
}
